import React from 'react';
import styled from 'styled-components';
import { TextButton } from 'components/v2/buttons';
import Tooltip from 'components/controls/Tooltip';
import { ReactComponent as MessageIcon } from 'images/v2/icons/svg/fill/svg/message.svg';
import { useShowEPDCommentLogButton } from 'hooks/useEPDCommentLogVisibility';
import { EpdLinks } from 'routes/EpdRoutes';

interface Props {
  epdId: string;
}

const WizardCommentLogButton: React.FunctionComponent<Props> = ({ epdId }) => {
  const showButton = useShowEPDCommentLogButton(epdId);

  if (!showButton) {
    return null;
  }

  return (
    <span>
      <TextButton
        type="button"
        text
        icon={<StyledMessageIcon />}
        onClick={() => window.open(EpdLinks.epdCommentLog(epdId), '_blank', 'noopener,noreferrer')}
      />
      <Tooltip position="bottom">Comment log</Tooltip>
    </span>
  );
};

const StyledMessageIcon = styled(MessageIcon)`
  display: block;
  width: 21px;
  height: 21px;
  margin-top: -4px;
  color: ${(props) => props.theme.colors.primaryOrange};

  button:hover & {
    color: ${(props) => props.theme.colors.elementsButtonHover};
  }
`;

export default WizardCommentLogButton;
